<template>
    <div class="relative form-time-picker">
        <FlatPickrWrapper v-model:value="computedValue" v-model:show="expandPicker" :disabled="disabled" :config="flatpickrConfig" mode="single">
            <div class="relative overflow-hidden">
                <CustomInput
                    ref="input-field"
                    v-model:value="inputValue"
                    :required="required"
                    :show-required-indication="required"
                    :rules="[]"
                    input-type="text"
                    :label="label"
                    :details="details"
                    :disabled="disabled"
                    readonly
                    cursor="cursor-pointer"
                    @submit="$emit('submit')"
                    @focus="expandPicker = true"
                ></CustomInput>
                <span v-if="!required" :class="[{ 'cursor-default opacity-40': disabled }, details ? '-mt-3.5' : '-mt-2']" class="absolute h-full top-0 right-14 grid content-center" @click="onClearClicked">
                    <Icon class="m-auto" :src="IconSource.Close"></Icon>
                </span>
                <span :class="[{ 'cursor-default opacity-40': disabled }, details ? '-mt-3.5' : '-mt-2']" class="absolute h-full top-0 right-5 grid content-center" @click="focusInputField()">
                    <Icon class="m-auto" :src="IconSource.TimePicker"></Icon>
                </span>
            </div>
        </FlatPickrWrapper>
    </div>
</template>

<script lang="ts">
import type { FieldDetails } from '@/mixins/validatableField';
import { defineComponent } from 'vue';
import CustomInput from '@/components/ui/CustomInput.vue';
import FlatPickrWrapper from '@/components/ui/FlatpickrWrapper.vue';

export default defineComponent({
    components: { FlatPickrWrapper, CustomInput },
    props: {
        value: {
            type: String as () => string | null,
            default: '',
        },
        label: {
            type: String,
            default: '',
        },
        disabled: {
            type: Boolean,
            default: false,
        },
        required: {
            type: Boolean,
            default: false,
        },
        details: {
            type: Object as () => FieldDetails | undefined,
            default: undefined,
        },
    },
    emits: ['update:value', 'submit'],
    data() {
        return {
            uid: `time-picker-${Math.random().toString(36).substring(6)}`,
            expandPicker: false,
            flatpickrConfig: {
                enableTime: true,
                noCalendar: true,
                dateFormat: 'Z',
                time_24hr: true,
            },
        };
    },
    computed: {
        computedValue: {
            get(): string | null {
                return this.$props.value;
            },
            set(newDateString: string | null) {
                this.$emit('update:value', newDateString);
            },
        },
        inputValue(): string {
            if (this.computedValue) {
                return this.$d(new Date(this.computedValue), 'clock');
            }
            return '';
        },
    },
    methods: {
        focusInputField() {
            (this.$refs['input-field'] as InstanceType<typeof CustomInput>).focusInput();
        },
        onClearClicked() {
            if (!this.$props.disabled) {
                this.computedValue = null;
            }
        },
    },
});
</script>

<style>
.form-time-picker .flatpickr-wrapper {
    top: 2rem;
}
</style>
